import { truncateLastLine } from './truncateLastLine.js';
import { truncateSingleLine } from './truncateSingleLine.js';
import { LINE_HEIGHT } from '@shopify/polaris-viz-core';

function endLineTruncate({
  label,
  targetWidth,
  targetHeight,
  characterWidths
}) {
  const isSingleLine = targetHeight <= LINE_HEIGHT;

  if (isSingleLine) {
    return truncateSingleLine({
      label,
      targetWidth,
      characterWidths
    });
  }

  return truncateLastLine({
    label,
    targetWidth,
    targetHeight,
    characterWidths
  });
}

export { endLineTruncate };
